
import { defineComponent, PropType } from 'vue'

export interface SelectComponent extends Vue {
  clearSelected(): void
}

export default defineComponent({
  name: 'SelectInput',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      required: true
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    removeYPadding: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    options: {
      type: Array as PropType<{ value: string; label: string }[]>,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get(): string | number {
        return this.value
      },
      set(value: string | number) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    modelValue(newValue: string | number) {
      if (newValue === '') {
        ;(this.$refs['select-input'] as SelectComponent).clearSelected()
      }
    }
  }
})
